import { time } from '@dr.pogodin/react-utils';

import type { GetVimeoVideoDataResT } from 'server/controllers/video/getVimeoVideoData';

import { getVimeoVideoData } from 'services/vimeoVideoData';

import { useAsyncCollection } from 'utils';

export default function useVimeoVideoData(
  ids: string[],
): Record<string, GetVimeoVideoDataResT> {
  const { items } = useAsyncCollection(
    ids,
    'vimeoVideoData',
    getVimeoVideoData,
    { maxage: time.DAY_MS },
  );

  const res: Record<string, GetVimeoVideoDataResT> = {};

  for (const [id, e] of Object.entries(items)) {
    if (e.data) res[id] = e.data;
  }

  return res;
}
